module.exports = __webpack_public_path__ + "img/Physician - Green.34760680.png";